import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IJobStatusUi } from '@app/core/job-status/models/job-status-ui.model';

@Component({
  selector: 'cnc-job-output-dialog',
  templateUrl: './job-output-dialog.component.html',
  styleUrls: ['./job-output-dialog.component.scss'],
})
export class JobOutputDialogComponent {
  formattedOutput: string;

  constructor(
    public dialogRef: MatDialogRef<JobOutputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { job: IJobStatusUi }
  ) {
    this.formattedOutput = this.formatOutput(data.job.output);
  }

  private formatOutput(output: any): string {
    if (!output) {
      return 'No output available';
    }

    try {
      // If it's already a string, try to parse it as JSON
      if (typeof output === 'string') {
        const parsed = JSON.parse(output);
        return JSON.stringify(parsed, null, 2);
      }
      
      // If it's an object, stringify it
      return JSON.stringify(output, null, 2);
    } catch (error) {
      // If it's not valid JSON, return as is
      return typeof output === 'string' ? output : String(output);
    }
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.formattedOutput).then(() => {
      // Could add a toast notification here
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
} 